import httpClient from "@/shared/http-eserv-client";

const getCategories = (type) => httpClient.get(`/Documents/PublicDocumentTypes`);
const deleteCategory = (categoryId) => httpClient.delete(`/StaticMessages/${categoryId}`);
const addUpdateCategory = (category) => httpClient.post("/StaticMessages", category);

const getDocumentsByCategory = (category) => httpClient.get(`/Documents/PublicDocuments?documentType=${category}`);
const addDocument = (document) => httpClient.post("/Documents/PublicDocument", document);
const deleteDocument = (id) => httpClient.delete(`/Documents/${id}`);

const getDocument = (documentId) => httpClient.get(`/Documents/OpenPublicDocument?documentId=${documentId}`);

export {
  getCategories,
  addUpdateCategory,
  deleteCategory,
  getDocumentsByCategory,
  addDocument,
  deleteDocument,
  getDocument,
};
